import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import FileUploadSingle from "../../../form/FileUploadSingle";
import { blogAddEdit } from "../../../../services/BlogService";

const validation = {
  image: { required: true, message: "image is required" },
  title: { required: true, message: "title is required" },
};

const ManagePartner = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    initialState: {
      image: "",
      title: "",
      type: "partner",
    },
    validationRules: validation,
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        image: data?.image?.url,
      });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await blogAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-4">
          <FileUploadSingle
            label={"Upload Partner Image"}
            value={values?.image}
            onChange={(file) =>
              handleChange({ target: { name: "image", value: file } })
            }
            {...formValidate(errors, "image")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="Title"
            value={values?.title}
            onChange={(val) =>
              handleChange({ target: { name: "title", value: val } })
            }
            {...formValidate(errors, "title")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={data?._id ? "Update Partner" : "Save Partner"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManagePartner;
